// Allow using reactive classes on body with
//
// Example: x-body-class:mobile="!$breakpoints('sm')" applies the "mobile" class
// to the body as long as the breakpoint "sm" does not match
export default Alpine => {
  Alpine.directive('body-class', (el, { value: className, expression }, { effect }) => {
    effect(() => {
      let condition = Alpine.evaluate(el, expression)
      document.body.classList.toggle(className, condition)
    })
  })
}
